<template>
  <path fill="currentColor" d="M13.4 24C6 24 0 18 0 10.6V4.5c0-.7.6-1.2 1.2-1.2h4.9c.7 0 1.2.5 1.2 1.2v4.9c0 .7-.5 1.2-1.2 1.2H4.9a8.4 8.4 0 0 0 8.3 8.5h.2v-1.2c0-.7.5-1.2 1.2-1.2h4.9c.7 0 1.2.5 1.2 1.2v4.9c0 .7-.5 1.2-1.2 1.2h-6.1zm-1.2-12.2V2.1h2.4v5.6L22.3 0 24 1.7l-7.7 7.6h5.6v2.4h-9.7z"/>
</template>
